import { StyleSheet, View, Text } from "react-native";
import SimplePress from "./SimplePress";
//import Ionicons from "react-native-vector-icons/Ionicons";
import { Ionicons } from "./VectorIcons";
import { getSchemeStyle } from "../context/helper";

const SensorMainItem = (props) => {
  const schemeStyles = getSchemeStyle();
  return (
    <View style={[styles.itemContainer,schemeStyles.Background,schemeStyles.Border]}>
      <View style={styles.textContainer}>
        <Text style={[styles.itemText,schemeStyles.grayText]}>{props.item.standortName}</Text>
      </View>
      <SimplePress onPress={props.onPress.bind(this,props.item)}>
        <Ionicons name={props.menuStyle==="kebap"?"ellipsis-vertical":"list-outline"} size={30} color={schemeStyles.grayIcon.color} />
      </SimplePress>
    </View>
  );
};

export default SensorMainItem;

const styles = StyleSheet.create({
  itemContainer: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
    paddingBottom: 5,
    borderBottomWidth: 1,
  },
  textContainer: {
    flex: 1,
  },
  itemText: {
    fontFamily: "Roboto-MediumItalic",
    fontSize: 18,
    marginLeft: 5,
  },
});
